import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";


export const addIllnesses = catchAsync(async (body) => {
    const { data } = await axiosInstance.post(
      `/api/resource/illnesses`,
      body
    );
    return data;
  });
export const updateIllnesses = catchAsync(async (body, editId) => {
    const { data } = await axiosInstance.put(
      `/api/resource/illnesses/${editId}`,
      body
    );
    return data;
  });

  export const getIllnesses = catchAsync(async (lang) => {
    const { data } = await axiosInstance.get(
      `/api/resource/illnesses?fields=["name","${lang}"]`
    );
    return data;
  });
  export const getIllnessesDetails = catchAsync(async (id) => {
    const { data } = await axiosInstance.get(
      `/api/resource/illnesses/${id}`
    );
    return data;
  });
  export const deleteIllnesses = catchAsync(async (id) => {
    const { data } = await axiosInstance.delete(
      `/api/resource/illnesses/${id}`
    );
    return data;
  });